import styled from 'styled-components';

import { Tree } from '@pega/cosmos-react-core';

export const StyledBaseTree: typeof Tree = styled(Tree)`
  &,
  & ul {
    padding: revert;
    list-style: revert;
  }
`;
